import { useCallback } from 'react';
import { useGetSendEmailSelector } from './useGetSendEmailSelector';

export const useGetTemplateSelector = () => {
  const getSendEmail = useGetSendEmailSelector();
  return useCallback((id: string) => getSendEmail(id)?.template, [getSendEmail]);
};
